import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    }
  }, [_c("el-form-item", [_c("el-radio-group", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.isOpen,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "isOpen", $$v);
      },
      expression: "searchForm.isOpen"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: "1"
    }
  }, [_vm._v("已开放")]), _c("el-radio-button", {
    attrs: {
      label: "0"
    }
  }, [_vm._v("待开放")]), _c("el-radio-button", {
    attrs: {
      label: "3"
    }
  }, [_vm._v("草稿")])], 1)], 1)], 1), _c("el-form", {
    attrs: {
      size: "small"
    }
  }, [_c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        _vm.form = {};
        _vm.dialogVisible = true;
      }
    }
  }, [_vm._v("新增 ")])], 1)], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "chCityName",
      label: "中文名称"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "digest",
      label: "简写"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "spell",
      label: "汉语拼音"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "enCityName",
      label: "英文名称"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "twCityName",
      label: "繁体名称"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "authCost",
      label: "认证费"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(_vm._s(scope.row.authCost) + "元 ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "serviceCost",
      label: "服务费"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(_vm._s(scope.row.serviceCost) + "% ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "排序",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          attrs: {
            placeholder: "序号",
            type: "number"
          },
          model: {
            value: scope.row.order,
            callback: function callback($$v) {
              _vm.$set(scope.row, "order", $$v);
            },
            expression: "scope.row.order"
          }
        }, [_c("el-button", {
          attrs: {
            slot: "append"
          },
          on: {
            click: function click($event) {
              return _vm.updateSort(scope.row);
            }
          },
          slot: "append"
        }, [_vm._v("保存 ")])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "address",
      label: "操作",
      width: "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.$router.push({
                path: "/base/district",
                query: {
                  id: scope.row.id,
                  name: scope.row.chCityName
                }
              });
            }
          }
        }, [_vm._v("区域 ")]), _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.$router.push({
                path: "/base/subway",
                query: {
                  id: scope.row.id,
                  name: scope.row.chCityName
                }
              });
            }
          }
        }, [_vm._v("地铁 ")]), _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.$router.push({
                path: "/base/city/strategy",
                query: {
                  id: scope.row.id,
                  name: scope.row.chCityName
                }
              });
            }
          }
        }, [_vm._v("攻略 ")])], 1), _c("div", [_c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.updateDialog(scope.row);
            }
          }
        }, [_vm._v("修改 ")]), _vm.searchForm.isOpen == 0 || _vm.searchForm.isOpen == 1 ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.updateCityStatus(scope.row);
            }
          }
        }, [_vm._v(_vm._s(scope.row.isOpen == 1 ? "关闭" : "开放") + " ")]) : _vm._e(), _vm.searchForm.isOpen == 0 || _vm.searchForm.isOpen == 3 ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.updateDraft(scope.row);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.searchForm.isOpen == 0 ? "转草稿" : "设为待开放") + " ")]) : _vm._e()], 1)];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.ps,
      "current-page": _vm.searchForm.pn,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("el-dialog", {
    attrs: {
      title: "城市编辑",
      width: "33%",
      visible: _vm.dialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      model: _vm.form,
      "label-position": "right",
      "label-width": "110px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "图片"
    }
  }, [_c("wlc-upload-image", {
    attrs: {
      url: _vm.form.img
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form, "img", $event);
      }
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "中文名称"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.chCityName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "chCityName", $$v);
      },
      expression: "form.chCityName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "英文名称"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.enCityName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "enCityName", $$v);
      },
      expression: "form.enCityName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "繁体名称"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.twCityName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "twCityName", $$v);
      },
      expression: "form.twCityName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "地区编码"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.code,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "code", $$v);
      },
      expression: "form.code"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "认证费(元)"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.authCost,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "authCost", $$v);
      },
      expression: "form.authCost"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "实名费(元)"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.realAuthCost,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "realAuthCost", $$v);
      },
      expression: "form.realAuthCost"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "服务费(%)",
      prop: "serviceCost"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.serviceCost,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "serviceCost", $$v);
      },
      expression: "form.serviceCost"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "CM起步价(元)"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.cityMasterStartingPrice,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cityMasterStartingPrice", $$v);
      },
      expression: "form.cityMasterStartingPrice"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "城市名称简写"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.digest,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "digest", $$v);
      },
      expression: "form.digest"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "城市名称拼音"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.spell,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "spell", $$v);
      },
      expression: "form.spell"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "经度"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.longitude,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "longitude", $$v);
      },
      expression: "form.longitude"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "纬度"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.latitude,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "latitude", $$v);
      },
      expression: "form.latitude"
    }
  })], 1), _vm.form.isOpen == 1 ? _c("el-form-item", {
    attrs: {
      label: "热门城市"
    }
  }, [_c("el-switch", {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: _vm.form.isHot,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isHot", $$v);
      },
      expression: "form.isHot"
    }
  })], 1) : _vm._e(), _c("el-form-item", {
    attrs: {
      label: ""
    }
  }, [_c("a", {
    staticStyle: {
      color: "red"
    },
    attrs: {
      href: "https://lbsyun.baidu.com/jsdemo.htm#kMapClickEvent",
      target: "_blank"
    }
  }, [_vm._v("快速获取经纬度")])])], 1), _c("div", {
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取 消 ")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("确 定 ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };